module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap5"
    }
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("“D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("U")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RÉ!” SAID")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADELAINE")]), _vm._v(". “You ask him to ask you them question I give you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yah,” said Du Pré. “He ask me I am fucking twelve women, like you keep telling me I am, I say no, the machine, it says I am lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Madelaine. “I thought so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is fourteen, anyway,” said Du Pré. “My dick, it is huge and it is very hungry. Twelve women, they do not quite do it for me, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Madelaine. “I fix that. You don’t be telling me, you have a headache, you hear.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded and grinned at her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now on, you don’t got time, fuck more than me,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Love is holy,” said Father Van Den Heuvel. “And never more so than when the two of you discuss it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The three of them were sitting at Madelaine’s kitchen table having lunch. Elk and vegetable soup and Madelaine’s good bread and home-canned corn and peppers.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The big, clumsy Belgian Jesuit had splotches of elk soup and kernels of corn down his cassock.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Been a while since he knock himself out shutting his head in his car door, Du Pré thought, he should maybe do that pretty soon again.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Three times the good priest had been found lying by his car, out cold. He was the clumsiest human being Du Pré had ever known. He was not allowed to split wood anymore. He had split his own foot so badly he was two years on crutches.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was maybe the only congregation in the world which laid bets on whether or not the priest would drop the Host during Communion.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was half a foot of snow outside on the ground. Even though it was the first week of June, it was Montana, and it seemed to snow at least every other year in early June. Late June.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It ever snow here in July?” said Father Van Den Heuvel. “I think it has snowed every other month.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yah,” said Du Pré. “We got two feet once, Fourth of July.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah,” said Father Van Den Heuvel, “God’s love is wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is sad, them girls, no one know who they are,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Only one of the three bodies could be identified. Father Van Den Heuvel had buried the unknown two this morning. The county had paid for the coffins.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Poor children,” said the big priest. “I wonder where their families are.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lots of runaway kids,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The pathologists had said that the two bodies that Du Pré had found were approximately sixteen. Dental work had been of minimal quality. One of the girls had a tattoo, the kind made in jails with pen inks and dull needles. A skull with a cross sticking out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("On the web of skin between thumb and forefinger of her left hand. The girl may have done it herself.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How come they bury them so quick?” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They get their samples and that is that,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Modern times.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Don’t want to pay the cold storage on them, Du Pré thought. These are not kids from nice homes. People who have some power, money. These kids, they will be forgotten. They always were forgotten. Their parents never even knew that they were there, I bet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Only Du Pré and Madelaine and Benny had come to the interment.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Benny left immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Father Van Den Heuvel had said his few words and then he and Du Pré and Benny had let the coffins down. They were very light.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Du Pré!” Madelaine said. “I want you to promise these two little girls that you will find who did this to them. They got no one else to speak for them, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yah,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You promise them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They don’t got names,” said Du Pré, “so I say, OK, you are my people, I find this bastard.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madelaine reached up and touched Du Pré on his cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Everybody is our people,” said Madelaine. “We are Métis.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded. That was true. The Mixed Bloods. That is pretty much everybody.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Long time ago, my people who were in France come to the New World and they marry my people who were already here. Then we really catch hell. Whites call us Indian, Indians call us whites. English, they hang us, steal our land. Send us all across Canada, move them furs for the Hudson’s Bay Company. The Here Before Christ. Most places they were, too.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Long time ago.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They come down here after them English crush the Red River Rebellion, got nothing, bunches of children.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Had each other, my people did.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("These poor girls, they have no one at all.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They got my Madelaine, who would feed all the world. Wipe all the tears.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They got me, too, I guess.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I find this bastard.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré rolled a cigarette while he waited for Father Van Den Heuvel to come back from taking a leak. The old police cruiser, light bar and sirens taken off, decals off the doors, still runs good. Runs fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There were a lot of cigarette burns on the backseat, where smokes Du Pré had flicked out the window flew back in.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré rolled a cigarette and he offered it to Father Van Den Heuvel. The big priest nodded and he took it. He had never tried to roll his own smoke. He couldn’t do it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I must go,” said the big priest. “I have to drive to Miles City and see Mrs. LeBlanc. She is dying.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I send her something?” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She can’t eat,” said Father Van Den Heuvel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madelaine dug around and she found a St. Christopher medal.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Father Van Den Heuvel put it in his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madelaine walked him out to his car. Du Pré had some more coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tomorrow, I got to go sign off, some cattle. His son-in-law, Raymond, did most of the brand inspections now, but Du Pré did what Raymond could not do. Cattle business was not too good. Hate someone, give them a cow. Cattle business was mostly not too good.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré heard the priest’s car drive off. Madelaine came back.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You sure like, devil that poor priest,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Poo,” said Madelaine. “Him like it. He is a nice man.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Devil me, too,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madelaine stood in front of him, hand on her hip.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Fourteen, huh?” she said. “You come on now, I show you some damn fourteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("After, Du Pré sat on the edge of the bed, smoking. Madelaine was in the shower. Du Pré could smell the potpourri soap she made, the smell of the steam from the hot water. The door to the bathroom was open and he could see her shape through the glass door of the shower.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fourteen, huh? Du Pré thought, I got as much trouble I need, just this Madelaine. She fuck good. I am a lucky man.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Where is old Benetsee? My old coyote friend. Him, he got things to tell me that I need to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Who is, this man does these things. What does he hide behind? Where is he going? I want to kill him, where do I wait.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Thing about good hunters, they wait well. Don’t bother them, they dream, don’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When Madelaine came out of the bathroom in her robe, toweling her thick long dark hair, Du Pré went in and he showered quickly. He dried himself and he got dressed and he went out to the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am going to Benetsee’s,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Madelaine nodded. “Him not back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Leave him a note,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t know, him read,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then you leave him note he don’t have to read,” said Madelaine. “You leave him a loaf of my good bread.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She went to the kitchen and she wrapped up a loaf of bread in foil and she put it in a plastic bag.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“His dogs all dead?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Du Pré nodded. Dogs got old, they died.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We get him another dog,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Du Pré. He did not ever argue with Madelaine. She had taught him not to do that.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Old man,” said Madelaine. “I pray for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You pray for everybody,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t pray for your fourteen other women,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Them don’t need it,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I find you, another woman, you need it,” said Madelaine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“OK,” said Du Pré.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You find that man,” said Madelaine.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c6828e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/9chap5.vue
// module id = 96
// module chunks = 0